<div bdFxLayout="row wrap" bdFxLayoutAlign="space-between start" class="container">

  <ng-container *ngTemplateOutlet="priceCards; context: { streetPrice: product?.streetPrice, itScopePrice: product?.itScopePrices?.price, brotherPricingAvailable: product?.brotherPrices !== null, fcAvailable: product?.brotherPrices !== null && (product?.brotherPrices?.fcBasePrice !== null || product?.brotherPrices?.fcPromotionOfferingBasePrice !== null) }"></ng-container>

  <div class="sub">
    * Alle Preise zzgl. MwSt. und {{product?.brotherPrices?.baseUhg | bdDePrice}} UHG, Cashback zzgl. MwSt.
    <div *ngIf="isMiddleProgramActive">** Unverbindlicher Distributionsabgabepreis. Bitte erfragen Sie Ihre Einkaufskonditionen bei Ihrem autorisierten Brother Distributor.</div>
  </div>
  <div class="footer">
    <div *ngIf="product?.itScopePrices?.supplierInfos?.length > 0" class="availability">
      <i class="fa fa-check"></i>
      Sofort verfügbar bei {{product?.itScopePrices.supplierInfos.length}} Distributoren
    </div>
    <div *ngIf="!product?.itScopePrices || product?.itScopePrices.supplierInfos.length === 0" class="availability not-available">
      <i class="fa fa-times"></i>
      Bei keinem Distributor verfügbar!
    </div>
    <button [disabled]="!product?.itScopePrices || product?.itScopePrices.supplierInfos.length === 0" (click)="distributorsModal.open()"
      class="show-distributors">Distributoren anzeigen</button>
  </div>
</div>



<bd-modal #distributorsModal [closable]="true" title="Distributoren">
  <div class="product-info">
    <div class="img">
      <img [src]="product?.images[0]" (error)="onImageError($event)" />
    </div>
    <div class="informations">
      <div class="header">
        <div class="title">{{product?.modelNumber}}</div>
        <div class="sub-title">{{product?.modelTitle}}</div>
      </div>
      <div class="footer">
        <div class="info">Gewünschte Menge:</div>
        <div class="actions">
          <bd-amount-setter [(amount)]="amount" [min]="0" [max]="0" (amountChange)="amountChange()"></bd-amount-setter>
          <button [disabled]="!activated" (click)="filterSupplierInfos()" class="show">Anzeigen</button>
        </div>
      </div>
    </div>
  </div>
  <bd-hr></bd-hr>
  <div *ngIf="activated && clicked && filteredSupplierInfos.length > 0" class="supplier-infos">
    <div *ngFor="let supplierInfo of filteredSupplierInfos" class="supplier-info">
      <div class="left">
        <div class="price">{{_parseInt(supplierInfo.price) === 0 ? '-' : supplierInfo.price | bdDePrice}}</div>
        <div *ngIf="_parseInt(supplierInfo.price) > 0" class="info">Zzgl. MwSt</div>
      </div>
      <div class="right">
        <div class="name">{{supplierInfo.supplierName}}</div>
        <div class="stock">
          <i class="fa fa-check"></i>
          {{supplierInfo.stockStatusText}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="activated && clicked && filteredSupplierInfos.length === 0" class="supplier-infos no-infos">
    Gewünschte Anzahl bei keinem Distributor verfügbar.
  </div>
</bd-modal>


<!-- BEGIN NG TEMPLATES FOR PRICE CARDS -->

<!-- STREET PRICE TEMPLATE -->
<ng-template #streetPriceTemplate let-fcAvailable="fcAvailable" let-price="price">
  <div bdFxFlex="1 1 calc(20% - 12px * 2 / 3)" [ngClass]="{ 'non-brother': true }">
    <div bdFxLayout="row" bdFxLayoutAlign="center center" class="header logo">
      <img src="assets/images/logo_geizhals-3x.png" />
    </div>
    <div bdFxLayout="row" bdFxLayoutja aber Align="center center" class="content">
      <div *ngIf="price && price.productPriceNoTax" bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content">
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Verfügbar ab:</div>

        <div *ngIf="product?.brotherPrices && product?.brotherPrices?.baseUhg" bdFxLayout="row" bdFxLayoutAlign="center end"
          class="price">{{_parseInt(price.productPriceNoTax.replace('EUR', '')) === 0 ? '-'
          : (_parseInt(price.productPriceNoTax.replace(' EUR', '')) - _parseInt(product?.brotherPrices?.baseUhg.replace('EUR',
          ''))).toString() | bdDePrice}}</div>
        <div *ngIf="!product?.brotherPrices || !product?.brotherPrices?.baseUhg" bdFxLayout="row" bdFxLayoutAlign="center end"
          class="price">{{_parseInt(price.productPriceNoTax.replace('EUR', '')) === 0 ? '-' :
          price.productPriceNoTax.replace(' EUR', '') | bdDePrice}}</div>

        <div bdFxLayout="row" bdFxLayoutAlign="center center" class="info">+ {{price.shippingPriceNoTax | bdDePrice}}
          Versand</div>
        <div bdFxLayout="row" bdFxLayoutAlign="center center" class="sub-info">
          Letzter Stand: {{price.lastUpdated | date: 'dd.MM.yyyy, HH.mm'}} Uhr</div>
      </div>
      <div *ngIf="!price" bdFxLayout="row" bdFxLayoutAlign="center center" class="price-content not-available">
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">Preis nicht verfügbar</div>
      </div>
    </div>
    <div *ngIf="fcAvailable" class="content">
      <div class="price-content">
        <div class="title"></div>
        <div class="price"></div>
        <div class="info background"></div>
      </div>
    </div>
  </div>
</ng-template>

<!-- IT SCOPE TEMPLATE -->
<ng-template #itScopeTemplate let-fcAvailable="fcAvailable" let-price="price">
  <div bdFxFlex="1 1 calc(20% - 12px * 2 / 3)" [ngClass]="{ 'non-brother': true, 'it-scope': true }">
    <div bdFxLayout="row" bdFxLayoutAlign="center center" class="header logo">
      <img src="assets/images/logo_itscope-3x.png" />
    </div>
    <div bdFxLayout="row" bdFxLayoutja aber Align="center center" class="content">
      <div *ngIf="!!price" bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content">
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Verfügbar ab:</div>


        <div *ngIf="product?.brotherPrices && product?.brotherPrices?.baseUhg" bdFxLayout="row" bdFxLayoutAlign="center end"
          class="price">{{_parseInt(price.replace('EUR', '')) === 0 ? '-'
          : (_parseInt(price.replace(' EUR', '')) - _parseInt(product?.brotherPrices?.baseUhg.replace('EUR',
          ''))).toString() | bdDePrice}}</div>
        <div *ngIf="!product?.brotherPrices || !product?.brotherPrices?.baseUhg" bdFxLayout="row" bdFxLayoutAlign="center end"
          class="price">{{_parseInt(price.replace('EUR', '')) === 0 ? '-' : price.replace(' EUR', '') | bdDePrice}}</div>


        <div *ngIf="!share.sharedModel.itScopeLoggedIn" bdFxLayout="row" bdFxLayoutAlign="center center" [ngClass]="{ 'info': true, 'long': fcAvailable }">
          <div class="text itscope">Bitte <b>ITscope Zugang</b> im Account
            hinterlegen.</div>
        </div>
      </div>
      <div *ngIf="!price" bdFxLayout="row" bdFxLayoutAlign="center center" class="price-content not-available">
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">Preis nicht verfügbar</div>
      </div>
    </div>
    <div *ngIf="fcAvailable" class="content">
      <div class="price-content">
        <div class="title"></div>
        <div class="price"></div>
        <div class="info background"></div>
      </div>
    </div>
  </div>
</ng-template>

<!-- BROTHER TEMPLATE -->
<ng-template #brotherTemplate let-pricingAvailable="pricingAvailable" let-fcAvailable="fcAvailable">
  <div bdFxFlex="1 1 calc(60% - 12px * 2 / 3)" class="brother">
    <div bdFxLayout="row" bdFxLayoutAlign="center center" class="header">
      Eigene Preise
    </div>
    <div bdFxLayout="row" bdFxLayoutAlign="stretch stretch" class="content">

      <div bdFxFlex="1 1 50%" bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content right-divider" [ngClass]="{ 'long': fcAvailable}">
        <ng-container *ngIf="product?.brotherPrices !== null">
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Unverbindlicher <br>Händlereinkaufspreis:</div>
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">{{getBasePrice() | bdDePrice}}</div>
        </ng-container>
      </div>

      <div *ngIf="isMiddleProgramActive" bdFxFlex="1 1 50%" bdFxLayout="column" bdFxLayoutAlign="center center" class="right-divider" [ngClass]="{ 'price-content': true, 'middle': true, 'long': fcAvailable, 'not-available': product?.brotherPrices === null }">
        <ng-container *ngIf="product?.brotherPrices !== null && !fcAvailable">
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Unverbindlicher Preis<br>Mittelstandsprogramm**:</div>
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">
            {{getMiddlePrice() | bdDePrice}}
          </div>
        </ng-container>
        <ng-container *ngIf="fcAvailable">
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Rahmenvertragspreis::</div>
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">{{getFcPrice() | bdDePrice}}</div>
        </ng-container>
        <ng-container *ngIf="product?.brotherPrices === null">
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">Preis nicht verfügbar</div>
        </ng-container>
      </div>

      <div bdFxFlex="1 1 50%" bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content">
        <ng-container *ngIf="product?.brotherPrices !== null">
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Cashback</div>
          <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">{{getCashback() | bdDePrice}}</div>
          <div bdFxLayout="row" bdFxLayoutAlign="center center" class="info">Nur begrenzte Menge<br>verfügbar</div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="fcAvailable" bdFxLayout="row" bdFxLayoutAlign="space-between start" class="content fc">
      <div bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content">
      </div>
      <div bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content">
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="title">Mittelstandspreis:</div>
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price">
          -
        </div>
        <div bdFxLayout="row" bdFxLayoutAlign="center end" class="price-info">Bitte bei Ihrem Distributionspartner anfragen</div>

      </div>
      <div bdFxLayout="column" bdFxLayoutAlign="center center" class="price-content">
      </div>
    </div>
  </div>
</ng-template>

<!-- CARDS TEMPLATE -->
<ng-template #priceCards let-streetPrice="streetPrice" let-itScopePrice="itScopePrice" let-brotherPricingAvailable="brotherPricingAvailable"
  let-fcAvailable="fcAvailable">
  <div bdFxLayout="row" bdFxLayoutAlign="space-between end" [ngClass]="{ 'price-cards': true, 'fc': fcAvailable, 'non-fc': !fcAvailable }">
    <ng-container *ngTemplateOutlet="streetPriceTemplate; context: { fcAvailable: fcAvailable, price: streetPrice }"></ng-container>
    <ng-container *ngTemplateOutlet="itScopeTemplate; context: { fcAvailable: fcAvailable, price: itScopePrice }"></ng-container>
    <ng-container bdFxFlex="1 1 calc(60% - 12px * 2 / 3)" *ngTemplateOutlet="brotherTemplate; context: { pricingAvailable: brotherPricingAvailable, fcAvailable: fcAvailable }"></ng-container>
  </div>
</ng-template>
